import { Component, Input, OnDestroy } from '@angular/core'
import { Subject } from 'rxjs'
import { JobsService } from '../../services/jobs.service'

@Component({
  selector: 'hs-exception',
  templateUrl: './exception.component.html',
})
export class ExceptionComponent implements OnDestroy {
  private readonly destroySubject$ = new Subject<void>()

  exception?: string

  isLoading = false

  @Input()
  set jobId(value: number) {
    this.loadData(value)
  }

  constructor(private readonly jobsService: JobsService) {}

  ngOnDestroy(): void {
    this.destroySubject$.next()
    this.destroySubject$.complete()
  }

  async loadData(jobId: number) {
    this.isLoading = true
    const data = await this.jobsService.getException(jobId).toPromise()

    this.exception = data?.exception
    this.formatException()

    this.isLoading = false
  }

  formatException() {
    if (!this.exception) {
      return
    }

    const lines = this.exception.replace(/\\n/g, '\n').replace(/\\t/g, '\t')
    this.exception = lines
  }
}
